import React, { Component } from 'react';
import Header from './Header';

export default class ProfileEdit extends Component {
  render() {
    return (
      <div data-testid="page-profile-edit">
        ProfileEdit
        <Header />
      </div>
    );
  }
}
